// The one place a table's scan URL is built, and the one place the address it is
// built from is judged. Signed QR auth is planned: adding a token is a change
// here and nowhere else.

/**
 * Where a printed code sends the customer.
 *
 * Not read off the window: staff print from the dashboard, but the customer page
 * is served on the voice agent's own host — the only one with a certificate and
 * the only origin from which the socket is same-origin. Set at build time; the
 * fallback is this origin, which is right for local development.
 */
export function scanBaseUrl(): string {
  return import.meta.env.VITE_QR_SCAN_BASE_URL || window.location.origin
}

/**
 * `table` carries table_number, NEVER the row id. The order payload accepts the
 * number; send an id and the order lands on a different table with nothing
 * erroring anywhere.
 */
export function tableScanUrl(base: string, propertyId: number, tableNumber: number): string {
  return `${base.replace(/\/+$/, '')}/t?property_id=${propertyId}&table=${tableNumber}`
}

/**
 * A code printed against an insecure origin is dead the moment a phone scans it
 * — the browser refuses the microphone. Worth saying out loud before a sheet of
 * them comes off the printer, but never worth blocking a print for, since the
 * page still has to work against a LAN address during testing.
 *
 * `base` is the app's own origin, so it always parses.
 */
export function hostWarning(base: string): string | null {
  const url = new URL(base)
  if (url.protocol === 'https:') return null
  // localhost is a secure context, so the mic works while developing.
  if (url.hostname === 'localhost' || url.hostname === '127.0.0.1') return null
  return 'Not https — phones block the microphone on an insecure origin, so voice ordering will not start from this code.'
}
